function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
var KEY_TAB = 9;
export var focusableElementsSelector = "\n    a[href],\n    area[href],\n    input:not([disabled]),\n    select:not([disabled]),\n    textarea:not([disabled]),\n    button:not([disabled]),\n    [tabindex=\"0\"]\n";
/**
 * Status: *in progress*.
 * Category: Misc
 *
 * Prevents focusing outside the container with using TAB keys
 */

function FocusTrap(_ref, ref) {
  var as = _ref.as,
      children = _ref.children,
      onKeyDown = _ref.onKeyDown,
      otherProps = _objectWithoutProperties(_ref, ["as", "children", "onKeyDown"]);

  var Element = as;

  var handleKeyDown = function handleKeyDown(event) {
    var focusableElements = ref.current.querySelectorAll(focusableElementsSelector);

    if (event.keyCode === KEY_TAB) {
      if (event.shiftKey) {
        if (document.activeElement === focusableElements[0]) {
          event.preventDefault();
          focusableElements[focusableElements.length - 1].focus();
        }
      } else if (document.activeElement === focusableElements[focusableElements.length - 1]) {
        event.preventDefault();
        focusableElements[0].focus();
      }
    }

    if (onKeyDown) onKeyDown(event);
  };

  return /*#__PURE__*/React.createElement(Element, _extends({
    ref: ref
  }, otherProps, {
    onKeyDown: handleKeyDown
  }), children);
}

var FocusTrapWithForwardRef = /*#__PURE__*/React.forwardRef(FocusTrap);
export default FocusTrapWithForwardRef;